import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';
import GrabChanceSection from '../OverseasEdutionFair/GrabChanceSection';
import HeaderSection from './onlineConunsellingHeader';
import AccomplishSection from '../OverseasEdutionFair/AccomplishSection';
import OnlineCounFooter from './footer';
import { MetaTagsComp } from '../MetaTagsComp';
import LazyReveal from '../LazyReveal';

const WhyOnlineCounselling = dynamic(() => import('./onlineCounsellingWhy'));
const Studyabroadjourney = dynamic(() => import('./studyabroadjourney'));
const WorldisyourCampus = dynamic(() => import('./theworldisyourcampus'));
const FirstStepWithKC = dynamic(() => import('./FirstStepWithKC'));
const Studywithscholarship = dynamic(() => import('./studywithscholarship'));
const WhyChoosKcStudyAbroad = dynamic(() => import('../OverseasEdutionFair/eduFairWhyChoosekc'));
const StudiesFAQ = dynamic(() => import('../AdmissionsDay/StudiesFAQ'));

const UniversityTiups = dynamic(() => import('./universityTiups'), { ssr: false });
const EduFairStudentTestimonials = dynamic(() => import('../OverseasEdutionFair/eduFairStudTestimonials'), { ssr: false });
const EduFairKcByNumber = dynamic(() => import('../OverseasEdutionFair/eduFairKcByNumber'), { ssr: false });

interface Props {
    eventData: any;
    
}

const CounsellingLanding: React.FC<Props> = ({ eventData }) => {
    useEffect(() => {
        const customStyle = document.documentElement.style
        customStyle.setProperty('--event-bgcolor', eventData?.bannerSection?.sectionBgColor || "#6C48F0");
    }, [])
    const router = useRouter();
    const { slug } = router.query;

    return (
        <>
           {eventData && <MetaTagsComp {...eventData.meta} />}
            {eventData?.bannerSection && <div>
                <HeaderSection data={eventData?.bannerSection} jotformId={eventData?.meta?.jotforms[0]?.jotformid} externalLink={eventData?.externalLink} slug={eventData?.slug}/>
            </div>}
            {eventData?.whyKcSection && <div>
                <WhyOnlineCounselling whykcdata={eventData?.whyKcSection} />
            </div>}
            {eventData?.kickstartSection && <div>
                <Studyabroadjourney studyabrdata={eventData?.kickstartSection}  slug={`${slug}`} jotformId={eventData?.meta?.jotforms[0]?.jotformid} externalLink={eventData?.externalLink}/>
            </div>}
            {eventData?.worldCampusSection && <div>
                <WorldisyourCampus worlddata={eventData?.worldCampusSection} />
            </div>}
            <GrabChanceSection eventData={eventData} />
            {eventData?.tieUpsSection && <div>
                <LazyReveal>
                    <UniversityTiups tiupdata={eventData?.tieUpsSection} />
                </LazyReveal>
            </div>}

            {eventData?.firstStepWithKcSection && <div>
                <FirstStepWithKC firstStepEventData={eventData?.firstStepWithKcSection} jotformId={eventData?.meta?.jotforms[0]?.jotformid} externalLink={eventData?.externalLink}/>
            </div>}

            {eventData?.stepUpSection && <div>
                <Studywithscholarship studyabroadjdata={eventData?.stepUpSection} jotformId={eventData?.meta?.jotforms[0]?.jotformid} externalLink={eventData?.externalLink}/>
            </div>}

            {eventData?.whyChooseKc && <div>
                <WhyChoosKcStudyAbroad data={eventData?.whyChooseKc} />
            </div>}
            <AccomplishSection eventData={eventData} />
            {eventData?.studentsSaySection && <div>
                <LazyReveal>
                    <EduFairStudentTestimonials data={eventData?.studentsSaySection} />
                </LazyReveal>
            </div>}
            {eventData?.kcNumbersSection && <div>
                <LazyReveal>
                    <EduFairKcByNumber data={eventData?.kcNumbersSection} />
                </LazyReveal>
            </div>}
            {eventData?.faqSection && <div>
                <StudiesFAQ faqdata={eventData?.faqSection} />
            </div>}
            {eventData?.footer && !router.asPath.includes('/online-counselling') && (
                <div>
                    <OnlineCounFooter data={eventData?.footer} />
                </div>
            )}
        </>
    )
}


export default CounsellingLanding;